/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */
import type { PaginationMetadataResponseDtoCursor } from './paginationMetadataResponseDtoCursor';

export interface PaginationMetadataResponseDto {
  skip: number;
  limit: number;
  total: number;
  /** @nullable */
  cursor?: PaginationMetadataResponseDtoCursor;
}
